<template>

   <div class="container">
       <div class="title text-left">{{ $t('impact.title') }}</div>
   </div>

 
<div   class="container text-justify pt-2 pb-2 ">


<div class="row mx-auto mt-5 mb-5">
    <div class="col mr-lg-5">
        <div class="mt-5 divoredTitle">{{ $t('impact.mission') }}</div>
        <h2 class="h2Title">
          {{ $t('impact.titleMission') }}
        </h2>
        <p class="mb-5">
          {{ $t('impact.contentMission') }}
        </p>
    </div>
    <div class="col-sm-12 col-md-6 order-first order-md-last">
      <img src="../../src/assets/img/impact/champsble.jpg" class="imgRounded img-fluid" alt="team-vm"/>
    </div>
</div>

<div class="highlighted text-center"> {{ $t('impact.objCarbon') }} </div>


<div class="row align-items-center">
  <div class="col mr-lg-5">
        <div class="mt-5 divoredTitle">Fleet</div>
        <h2 class="h2Title">
          {{ $t('impact.fleetTitle') }}
        </h2>
        <p class="mb-5">
          {{ $t('impact.fleetContent') }}
        </p>
    </div>
  <div class="col-sm-12 col-md-6 order-first order-md-last">
      <img src="../../src/assets/img/impact/transport.jpg" class="imgRounded img-fluid" alt="team-vm"/>
    </div>
</div>

</div>

<MailjetNewsLetter/>

</template>

<script >
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
    name: 'Agrivitechpourleclimat',
    components:{
        MailjetNewsLetter
    },
    props:{},
    metaInfo() {
        return { 
            title: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !",
            meta: [
                { name: 'robots', content: 'index,follow'},
                { name: 'title', content: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !"},
                { name: 'description', content: "Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !"},
                { property: 'og:title', content: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !"},
                { property: 'og:description', content: "Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !"},
                { property: 'og:site_name', content: 'AgriVitech'},
                { property: 'og:type', content: 'website'},    
                { property: 'og:url', content: 'https://www.agrivitech.com.com'},
                { property: 'og:image', content: 'https://www.agrivitech.com/seo-impact.png' },
                { property:"twitter:card", content:"summary_large_image"},
                { property:"twitter:url" , content: 'https://www.agrivitech.com.com'},
                { property:"twitter:title" , content:"AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !" },
                { property:"twitter:description" , content:"Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !" },
                { property:"twitter:image" , content:'https://www.agrivitech.com/seo-impact.png' }
            ]
        }
    }
    
}
</script>

<style lang="scss" scoped>

 .container-fluid{
     padding-left: 5vh;
     padding-right: 5vh;
     .card{
        border-radius: 20px;
        padding: 20px;
        .highlighted{
            padding: 0px;
            margin: 0px;
        }
     }
 }

 
.imgRounded {
  border-radius: 15px;
}

.headerImpact {
  height: 400px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
//   color: $primary-color;

  h2 {
    position: relative;
    font-size: 50px;
    // color: $primary-color;
    font-weight: 700;
  }

  .titleBackground {
    position: relative;
    font-size: 40px;
    line-height: 0.9;
    text-align: center;
    font-weight: 600;
  }

  .numberBackground {
    position: relative;
    font-size: 50px;
    text-align: center;
    font-weight: 700;
  }

  .textBackground {
    position: relative;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
  }
}

.h2Title {
  position: relative;
  font-size: 35px;
//   color: $primary-color;
  font-weight: 800;
}

.textImpact {
  line-height: 1.6;
  font-size: 18px;
  font-weight: 400;
//   color: $primary-color;
  li {
    padding-bottom: 20px;
  }
  .titleLine {
    text-align: center;
    // color: $green-btn;
    font-size: 20px;
    font-weight: 600;
  }
}

.coloredTitle {
//   color: $secondary-color;
  font-weight: 500;
  text-transform: uppercase;
}
.impactBlock {
  padding: 30px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 25px;
//   color: $primary-color;
  margin-bottom: 15px;
  background-color: "#e8e6f6";
  height: 100%;
  .title {
    font-size: 17px!important;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .content {
    font-size: 14px;
  }
  &.a{
    background-color: #adffe2;
  }
  &.b{
    background-color: #e4fff5;
  }
  &.c{
    background-color: #d7fff0;
  }
}

</style>